export default "__VITE_ASSET__y3SpnoVf__"